export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8089.a8ec38e0.jpg";